module.exports = __webpack_public_path__ + "static/img/2.e167e18.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/showcase/xi/detail/hospital1/2.png
// module id = l8EA
// module chunks = 1